/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Feat3_BodyInputs */

const es_exp_mk_feat3_body = /** @type {(inputs: Exp_Mk_Feat3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tienes barco? Abre plazas, defiende los gastos del día y navega acompañado.`)
};

const gl_exp_mk_feat3_body = /** @type {(inputs: Exp_Mk_Feat3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes barco? Abre prazas, defende os gastos do día e navega acompañado.`)
};

const en_exp_mk_feat3_body = /** @type {(inputs: Exp_Mk_Feat3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a boat? Open places, split the day's costs and sail with company.`)
};

/**
* | output |
* | --- |
* | "Have a boat? Open places, split the day's costs and sail with company." |
*
* @param {Exp_Mk_Feat3_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_feat3_body = /** @type {((inputs?: Exp_Mk_Feat3_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Feat3_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_feat3_body(inputs)
	if (locale === "en") return en_exp_mk_feat3_body(inputs)
	return es_exp_mk_feat3_body(inputs)
});